<template>
  <m-pay-layout>

      <v-layout justify-center align-top class="mx-2">
        <v-flex grow>
          <m-pay-generic-paging-table
            :headers="headers"
            :queryFunctionName="queries.merchantOrders.name"
            :cellClasses="cellClasses"
          >

            <template slot-scope={item} slot="details">
              <router-link :to="{ name: 'order', params: { orderId: item.id } }">
                <v-tooltip bottom>
                      <span slot="activator">
                        <v-icon color="secondary">zoom_in</v-icon>
                      </span>
                  <span>Order Details</span>
                </v-tooltip>
              </router-link>
            </template>
            <template slot-scope={item} slot="purchase">
              <router-link :to="{ name: 'purchase', params: { purchaseId: item.purchaseId } }">
                <v-tooltip bottom>
                      <span slot="activator">
                        <v-icon color="secondary">shopping_cart</v-icon>
                      </span>
                  <span>Purchase</span>
                </v-tooltip>
              </router-link>
            </template>
            <template slot-scope={item} slot="credit" v-if="item.consumerCreditId">
              <router-link :to="{
                name: 'consumer-credit',
                params: { consumerCreditId: item.consumerCreditId } }"
              >
                <v-tooltip bottom>
                    <span slot="activator">
                      <v-icon color="secondary">euro</v-icon>
                    </span>
                  <span>Loan Details</span>
                </v-tooltip>
              </router-link>
            </template>
            <template slot-scope={value} slot="status">
              <m-pay-status :value-classes="orderStatusClasses" :value="value"/>
            </template>
            <template slot-scope={item} slot="offerSummary">
              {{ item.okOfferCount }}/{{ item.allOfferCount }}
            </template>
          </m-pay-generic-paging-table>
        </v-flex>
      </v-layout>

    </m-pay-layout>
</template>

<script>
import MPayGenericPagingTable from '../MPayGenericPagingTable';
import MPayStatus from '../MPayStatus';
import roles from '../../utils/user-roles';
import { orderStatusClasses } from '../../utils/statuses';

export default {
  name: 'MPayMerchantOrdersPage',
  components: { MPayGenericPagingTable, MPayStatus },
  data: () => ({
    merchantEmployees: [],
    totalMerchantEmployees: 0,
    merchant: {},
    headers: [
      { text: '', value: 'details', sortable: false, filterable: false },
      { text: '', value: 'purchase', sortable: false, filterable: false },
      { text: '', value: 'credit', sortable: false, filterable: false },
      { text: 'ID', value: 'id', sortable: false, filterable: true, width: 180 },
      { text: 'External ID', value: 'externalId', sortable: false, filterable: true, width: 180 },
      { text: 'Merchant  Order Number', value: 'externalOrderNumber', sortable: false, filterable: true, width: 180 },
      { text: 'Payment Method', value: 'paymentMethod', sortable: false, filterable: true, width: 180 },
      { text: 'Status', value: 'status' },
      { text: 'Amount', value: 'amount', sortable: true, filterable: true, align: 'right' },
      { text: 'Currency', value: 'currency', sortable: false, filterable: false },
      { text: 'Label', value: 'label' },
      { text: 'Created At', value: 'createdDate', sortable: true, filterable: true, width: 150 },
      { text: 'Merchant', value: 'merchantName', sortable: true, filterable: true, roles: [roles.READ_ANY_PURCHASE], width: 200 },
      { text: 'Offers OK/All', value: 'offerSummary', sortable: false, filterable: false, width: 50, align: 'center' },
      { text: 'Error', value: 'error', sortable: true, filterable: true, roles: [roles.READ_ANY_PURCHASE], width: 200 },
    ],
    cellClasses: {
      details: 'pl-3 pr-1',
      purchase: 'pl-0 pr-1',
      credit: 'pl-0 pr-1',
    },
    loading: false,
    orderStatusClasses,
  }),
  methods: {

  },
};
</script>



// WEBPACK FOOTER //
// src/components/merchant/MPayMerchantOrdersPage.vue